var map = {
	"./collection.svg": "55c9",
	"./comm_icon_gou.svg": "a2c4",
	"./draw-histroy.svg": "59a8",
	"./draw-money-icon.svg": "5f25",
	"./draw-qa.svg": "733c",
	"./draw-right.svg": "2c28",
	"./draw-title.svg": "5377",
	"./draw-voice.svg": "c9ac",
	"./icon-file.svg": "7eaa",
	"./input_icon_fb.svg": "7592",
	"./input_icon_telegram.svg": "0f54",
	"./input_icon_wechat.svg": "2c5f",
	"./input_icon_whatsapp.svg": "a491",
	"./mes.svg": "e556",
	"./nem-sems-a.svg": "b58e",
	"./no_collection.svg": "091d",
	"./receberbox.svg": "b101",
	"./saveImage.svg": "1cd8",
	"./share-logo.svg": "52c6",
	"./sprite.svg": "cb7e",
	"./svg.svg": "89b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";